// extracted by mini-css-extract-plugin
module.exports = {"root":"Explorer_root__chK41","title":"Explorer_title__Faoun"};